// extracted by mini-css-extract-plugin
export default {"img":"HomePageCheckTypeModal_img__rWV7-"};